// extracted by mini-css-extract-plugin
module.exports = {"Download":"Download_Download__3foyP"};